import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import classes from './HeaderStore.module.css';

const HeaderStore = props => {
  const url = window.location.pathname.split('/');
  const [searchText, setSearchText] = useState('');
  const [valueTab, setValueTab] = useState(props.section);

  useEffect(() => {
    if (!url[2]) {
      props.changeSection('all');
      setValueTab('all');
    } else {
      setValueTab(props.section);
    }
  }, [url, props.section]);

  const searchBarHandler = event => {
    setSearchText(event.target.value);
    props.searchHandler(event.target.value);
  };

  const handleChange = (event, newValue) => {
    props.changeSection(newValue);
    setValueTab(newValue);
  };

  return (
    <div className={classes.searchContainer}>
      <aside className={classes.imageContainer}>
        <figure className={classes.imgAvatar}>
          <img
            className={classes.img}
            src="https://d1g6c01s9ssd7h.cloudfront.net/img/eduStore2x.png"
            alt=""
          />
        </figure>
        <p className={classes.imgText}>EduStore</p>
      </aside>
      <TextField
        className={classes.searchInput}
        placeholder="Qué quieres aprender hoy?"
        value={searchText}
        variant="outlined"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          className: classes.searchInputModificated
        }}
        onChange={searchBarHandler}
      />
      <Button
        className={classes.createAcademyBtn}
        component={Link}
        to="/createAcademy"
      >
        Enseña con Mayahii
      </Button>
      <Tabs
        TabIndicatorProps={{ style: { background: '#333549' } }}
        className={classes.storeBar}
        value={valueTab}
        onChange={handleChange}
      >
        <Tab
          className={
            valueTab === 'books'
              ? classes.itemSelected
              : classes.item
          }
          component={Link}
          to="/store/books"
          label="Libros"
          value="books"
        />
        <Tab
          className={
            valueTab === 'courses'
              ? classes.itemSelected
              : classes.item
          }
          component={Link}
          to="/store/courses"
          label="Cursos y Diplomados"
          value="courses"
        />
        <Tab
          className={
            valueTab === 'degrees'
              ? classes.itemSelected
              : classes.item
          }
          component={Link}
          to="/store/degrees"
          label="Licenciaturas"
          value="degrees"
        />
        <Tab
          className={
            valueTab === 'posgrados'
              ? classes.itemSelected
              : classes.item
          }
          component={Link}
          to="/store/posgrados"
          label="Posgrados"
          value="posgrados"
        />
      </Tabs>
    </div>
  );
};

HeaderStore.propTypes = {
  // eslint-disable-next-line react/require-default-props
  changeSection: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  section: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  searchHandler: PropTypes.func
};

export default HeaderStore;
